<template>
  <div style="display:inline;">
    <template v-if="error===107 && (payload.type=='qw')">
      <qw-dd-bind :weworkuserinfo="payload.weworkuserinfo" />
    </template>
    <template v-else-if="!error && (payload.type!=='pay')" />
    <template v-else>
      <login-layout :title="layoutTit">
        <div
          v-if="error && (error !==107)"
          class="login-suc-box"
        >
          <i
            class="icon iconfont icon-clear  error-ico"
            :class=" $ua.isMobile ? 'iconicon-test1' : 'iconicon-test13'"
          />
          <p>{{ message }}</p>
          <p>
            <template v-if="payload.type === 'pay'">
              <a :href="payload.formurl">{{ $t('message["1622"]') }}</a>
            </template>
            <template v-else-if="payload.type !== 'dingtalkservice'">
              {{ duration }}{{ !$store.state.auth ? $t('message["640"]') : $t('message["641"]') }}
            </template>
          </p>
        </div>
        <template v-else>
          <div
            class="login-suc-box"
          >
            <i
              class="icon iconfont  suc-ico"
              :class=" $ua.isMobile ? 'iconicon-test' : 'iconicon-test70'"
            />
            <p>{{ message }}</p>
            <p>
              <!-- <template v-if="payload.type==='pay'">{{ duration }}</template>
              <template v-else>{{ duration2 }}</template> -->
              {{ duration }}
              {{ $t('message["641"]') }}
            </p>
          </div>
        </template>
      </login-layout>
    </template>
  </div>
</template>
<script>
// import { setAuth } from '@/common'
import LoginLayout from '@/components/pc/account/LoginLayout'
import QwDdBind from './QwDdBind'
import { setAuth, getAuth } from '@/lib/storage'
import { mapActions, mapMutations } from 'vuex'
import { isMobile } from '@/lib/device'
import Cookies from 'js-cookie'
export default {
  components: {
    LoginLayout,
    QwDdBind
  },
  data () {
    return {
      duration: 3,
      duration2: 5,
      error: 0,
      message: '',
      payload: {}
    }
  },
  computed: {
    datas () {
      const { query = {} } = this.$route
      const { param: paramStr = '' } = query
      if (paramStr) {
        const param = JSON.parse(decodeURIComponent(paramStr))
        const { payload = {} } = param
        return payload
      }
      return {}
    },
    layoutTit () {
      return this.$t('message["1381"]')
    }
  },
  async mounted () {
    // TODO: 修改为选择企业及项目的页面地址
    let url = { name: 'AccountLogin' }
    try {
      const { query = {} } = this.$route
      const { param: paramStr = '' } = query
      if (paramStr) {
        const param = JSON.parse(decodeURIComponent(paramStr))
        const { error, payload = {}, message } = param
        this.error = error
        this.message = message
        this.payload = payload
        if (!error) {
          const { Authorization = '', fromurl = '/' } = payload
          if (this.payload.type === 'dingtalkservice' && !Cookies.get('dingTalk')) {
            Cookies.set('dingTalk', 'dingding')
          }
          if (Authorization) {
            setAuth(Authorization)
            this.$store.commit('setAuth', Authorization, { root: true })
          } else {
            this.$store.commit('setAuth', getAuth(), { root: true })
          }
          url = fromurl || '/'
        } else if (error === 101 && (payload.type === 'pay' || payload.type === 'qw' || payload.type === 'ocpc')) {
          const { Authorization = '', fromurl = '/' } = payload
          if (Authorization) {
            setAuth(Authorization)
            this.$store.commit('setAuth', Authorization, { root: true })
          } else {
            this.$store.commit('setAuth', getAuth(), { root: true })
          }
          url = fromurl || '/'
        }
      } else {
        this.error = 100
        this.message = this.$t('message["77"]')
      }
    } catch (err) {
      // console.log(err)
    }
    // console.log('url: ', url)
    if ((this.error && this.error !== 107) || (!this.error && this.payload.type === 'pay')) {
      if (this.payload.type !== 'dingtalkservice') {
        const interval = setInterval(() => {
          if (this.duration > 1) {
            this.duration--
          } else {
            if (this.isOjb(url) && (url.indexOf('https://') > -1 || url.indexOf('http://') > -1)) {
              location.href = url
            } else {
              if (this.error === 101 && !!getAuth() && (this.payload.type !== 'ocpc')) {
                url = '/'
              }
              this.$router.push(url)
            }
            clearInterval(interval)
          }
        }, 1000)
      }
    } else {
      if (this.error !== 107) {
        // const interval = setInterval(() => {
        //   if (this.duration2 >= 1) {
        //     this.duration2--
        //   } else {
        //     this.$router.push(url)
        //     clearInterval(interval)
        //   }
        // }, 1000)

        // if ((this.isOjb(url) && url.indexOf('https://') > -1) || (this.isOjb(url) && url.indexOf('http://') > -1)) {
        //   location.href = url
        // } else {
        //   this.$router.push(url)
        // }
        if (this.datas.projectStr) {
          await this.specialTo()
        } else {
          if ((this.isOjb(url) && url.indexOf('https://') > -1) || (this.isOjb(url) && url.indexOf('http://') > -1)) {
            location.href = url
          } else {
            this.$router.push(url)
          }
        }
      }
    }
  },
  methods: {
    ...mapActions(['permissionMenu']),
    ...mapMutations(['setRoleDefault']),
    isOjb (url) {
      const isobj = Object.prototype.toString.call(url) === '[object Object]'
      return !isobj
    },
    async specialTo () {
      const { datas } = this
      this.$store.commit('setPid', datas.projectStr)
      let to = ''
      let linkName = ''
      let routerName = 'InqueryList'
      switch (datas.system_role * 1) {
        case 1: // 负责人, 观察员
          linkName = { type: 'inquiry-manager-all', from: 'all' }
          break
        case 2: // 开发
          linkName = { type: 'inquiry-dev', from: 'my' }
          break
        case 3: // 接待
          linkName = { type: 'inquiry-add', from: 'my' }
          break
        default: // 销售
          linkName = { type: 'inquiry-followup', from: 'my' }
      }
      const pid = datas.projectStr // this.$store.state.pid
      if (!isMobile) {
        if (datas.system_role * 1 === 0) {
          this.setRoleDefault(true)
          const chain = await this.permissionMenu() // 先请求菜单数据，判断自定义角色默认展示页
          chain.params({ cid: datas.cid * 1, projectid: datas.projectid * 1 })
            .onSuccess(res => {
              for (let key in res) {
                if (key === 'inquiry-mine' && res[key]['state']) {
                  let item = res[key]
                  if ('child' in item) {
                    for (let cKey in item['child']) {
                      linkName = { type: cKey, from: 'my' }
                      break
                    }
                  }
                  break
                }
                if (key === 'inquiry-mine' && !res[key]['state']) {
                  // console.log('查重： inquiry-check-repeat')
                  routerName = 'InqueryRepeat'
                  linkName = {}
                  break
                }
              }
            }).onComplete((raw) => {
              // console.log(linkName)
              to = {
                name: routerName,
                params: {
                  pid
                },
                query: linkName
              }
              this.$router.push(to)
            }).fetch()
        } else {
          to = {
            name: routerName,
            params: {
              pid
            },
            query: linkName
          }
          this.$router.push(to)
        }
      } else {
        to = {
          name: 'ProjectIndex',
          params: {
            pid
          },
          query: {
            cid: datas.cid * 1
          }
        }
        this.$router.push(to)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .login-suc-box {
    text-align: center;
    padding-top: 50px;
    padding-bottom: 120px;

    i {
      margin: 0 auto 16px;
      display: block;
      font-size: 56px;
    }

    p {
      line-height: 24px;
      font-weight: bold;
    }
    .suc-ico {
      color: #42c27e;
    }
    .error-ico {
      color:#f57676;
    }
  }
</style>
